import useVuexModule from '@shared/composables/vuexModule.js'
import { acceptHMRUpdate, defineStore } from 'pinia'
import { ref } from 'vue'
import { useRouter } from 'vue-router'

// TODO: Partial implementation (ENG-2854)
export const useReviewStore = defineStore('review', () => {
  const vuex = useVuexModule('review')

  const router = useRouter()

  const skippedItemIds = ref(new Set())

  /**
   * @param {{id: string}[]|string[]|{id: string}|string} items
   * @param {number} reviewItemIndex - The index of the item to review
   * @param {boolean} [single] - Use the single item review flow
   */
  function navigateToItemReview (items, reviewItemIndex = 0, single = undefined) {
    if (!Array.isArray(items)) {
      items = [items]
    }
    const reviewItemIds = items.map(item => item.id ?? item).join(',')
    const query = single ? { single } : {}
    router.push({ name: 'review-item', params: { reviewItemIds, reviewItemIndex }, query })
  }

  /** @param {{id: string}|string} item */
  function navigateToReviewSingleItem (item) {
    navigateToItemReview(item, 0, true)
  }

  return {
    ...vuex,
    skippedItemIds,
    navigateToItemReview,
    navigateToReviewSingleItem,
  }
})

import.meta.hot?.accept(acceptHMRUpdate(useReviewStore, import.meta.hot))
